import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { BarChart3, TrendingUp, Users, Target } from 'lucide-react'
import { useAuth } from '@/auth'

export function DashboardPage() {
  return (
    <div className="space-y-8">
      {/* Empty dashboard page as requested */}
    </div>
  )
} 